// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"de58a6b5","608":"758f7a90","716":"356592e2","868":"bd0c7de5"}[chunkId] + ".chunk.css";
};